import styled from 'styled-components';
import {theme} from '@styles/theme';

export const CircleButtonBlockWrapper = styled.div`
  position: relative;
`;

export const CircleButtonWrapper = styled.button`
  position: relative;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 32px;
  border: 0;
  outline: none;
  cursor: pointer;
  background-color: ${theme.colors.basic07};
  &:hover {
    background-color: ${theme.colors.basic06};
  }
  &:active {
    background-color: ${theme.colors.basic05};
  }
`;

export const OverflowMenuWrapper = styled.div`
  position: absolute;
  top: 32px;
  right: 0;
  text-align: left;
  padding: 8px;
  background-color: ${theme.colors.basic08};
  border: 1px solid ${theme.colors.basic05};
  border-radius: ${theme.roundedMedium};
  cursor: default;
  white-space: nowrap;
  z-index: 99;
`;

export const OverflowMenuItemWrapper = styled.div`
  padding: 8px;
  border: 0;
  border-radius: ${theme.roundedSmall};
  color: ${theme.colors.accent00};
  cursor: pointer;
  &:hover {
    background-color: ${theme.colors.basic07};
  }
  &:active {
    background-color: ${theme.colors.basic06};
  }
`;
